import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-add-local-user', {
    width: '100%',
});

cssRule('.tb-add-local-user .tb-error-text', {
    color: applyColor(DesignTokens.color.font.default.error, '#c41723'),
});

cssRule('.tb-add-local-user .tb-form-table', {
    marginBottom: '18px',
    width: '100%',
});

cssRule('.tb-add-local-user .tb-form-table .tb-text-input-label-cell', {
    width: '120px',
});

cssRule('.tb-add-local-user .tb-form-table .tb-react-text-input-label-cell', {
    width: '25%',
});

cssRule('.tb-add-local-user .tb-form-table .tb-react-site-role-popover', {
    width: '8%',
});

cssRule('.tb-add-local-user .tb-form-table .tb-immutable-text-cell', {
    paddingBottom: '6px',
    height: '23px',
});

cssRule('.tb-add-local-user .tb-form-table .tb-newUserFlow-table .tb-available-cell', {
    height: '18px',
});

cssRule('.tb-add-local-user .tb-form-table .tb-newUserFlow-table .tb-available-text', {
    color: applyColor(DesignTokens.color.link.inline.default.default, '#1a699e'),
});

cssRule('.tb-add-local-user .tb-form-table .tb-otherSiteFlow-table .tb-warning-cell', {
    height: '23px',
    paddingBottom: '6px',
});

cssRule('.tb-add-local-user .tb-form-table .tb-otherSiteFlow-table .tb-proceed-button', {
    float: 'right',
});

cssRule('.tb-add-local-user .tb-form-table .tb-otherSiteFlow-table .tb-warning-text', {
    color: applyColor(DesignTokens.color.font.default.error, '#c41723'),
    marginRight: '12px',
    float: 'right',
});

cssRule('.tb-add-local-user .tb-form-table .tb-notAvailableFlow-table .tb-error-cell', {
    height: '23px',
    paddingBottom: '6px',
});

